<template>
    <div class="d-block">
        <page-banner v-bind:data="bannerData" v-if="bannerData"/>

        <div class="business-wrapper">
            <div class="rotation-container">
                <a class="logo">
                    <img alt="" src="static/images/img-logo-pic-green@160px.png"/>
                </a>
                <div id="rotation-one">
                    <div class="item" v-for="(item, index) in businessList" :key="index">
                        <Poptip trigger="hover" placement="bottom-start" :width="480">
                            <img alt="" :src="item.icon"/>
                            <div class="rotation-content" slot="content">
                                <h2 @click="onBusiness(item, index)">{{ item.title }}</h2>
                                <div class="d-flex">
                                    <span class="cover" @click="onBusiness(item, index)">
                                        <img alt="" :src="item.cover"/>
                                    </span>
                                    <div class="d-flex-item pl-sm">
                                        <div class="d-flex flex-column">
                                            <div class="d-flex-item" @click="onBusiness(item, index)">
                                                <div class="d-flex justify-start">
                                                    <div data-box="text-box" class="d-flex-item" :style="{height: item.targetUrl !== '' ? '68px' : '', marginBottom: item.targetUrl !== '' ? '12px' : ''}">{{ item.introduction }}</div>
                                                    <Icon type="ios-arrow-forward" size="18" color="#7D7E80"/>
                                                </div>
                                            </div>
                                            <a class="d-block" target="_blank" :to="item.targetUrl" v-if="item.targetUrl !== ''">
                                                <Button type="success" ghost>{{ language === 'zh-cn' ? '官网' : 'Web Site'}}</Button>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Poptip>
                    </div>
                </div>
                <div id="rotation-two">
                    <span class="item" v-for="(item, index) in 11" :key="index"/>
                </div>
            </div>
            <iframe :src="canvasPage" frameborder="0" style="width: 100%; height: 880px;"></iframe>
        </div>

        <span class="d-block" style="height: 80px;">&nbsp;</span>

        <details-modal v-if="isDetailsModal" v-bind:lang="language" v-bind:data="detailsModalData" @actions="detailsModalActions"/>
    </div>
</template>

<script type="text/javascript">
    import PageBanner from "../../components/PageBanner";
    import DetailsModal from "../../components/DetailsModal";
    import $ from 'jquery';

    export default {
        components: {
            PageBanner, DetailsModal
        },
        data () {
            return {
                canvasPage: 'static/canvas/index.html',
                language: 'zh-cn',
                bannerData: null,
                businessList: [],
                isDetailsModal: false,
                detailsModalData: null,
                total: 0,
                current: 1,
                pageSize: 10,
            }
        },
        created() {
            console.log('当前语言----->' + this.$store.state.language);
            this.language = this.$store.state.language;
        },
        mounted() {
            setTimeout(()=>{
                console.log($('#list-container'));
                this.autoRotation();
            }, 1000);
            this.__getBanner();
            this.__getBusinessList(1);
        },
        methods: {
            __getBanner(){
                this.$api.getHttp('banner?bannerType=BUSINESS', {
                    language: this.language,
                }).then((res) => {
                    // console.log('<---------- res ---------->');
                    // console.log(res);
                    if (res.status === 200){
                        this.bannerData = res.data.data;
                    } else {
                        this.$Message.error('数据加载错误');
                    }
                }).catch((err) => {
                    this.$Message.error(err.message);
                });
            },

            __getBusinessList(page){
                this.$api.getHttp('business?pageIndex=' + page + "&pageSize=" + this.pageSize, {
                    language: this.language,
                }).then((res) => {
                    // console.log('<---------- res ---------->');
                    // console.log(res);
                    if (res.status === 200){
                        this.total = res.data.data.total;
                        var _data = res.data.data.data;
                            if (this.language === 'zh-cn'){
                                _data.forEach(item=>{
                                    if (item.id === '5f2b9ba777337d1f84c2d93b'){
                                        item.icon = 'static/icon/icon-business-info-cn-01@128px.png';
                                    } else if (item.id === '5f2a7ca077337d1f84c2d934'){
                                        item.icon = 'static/icon/icon-business-info-cn-02@128px.png';
                                    } else if (item.id === '5f2b9b8d77337d1f84c2d93a'){
                                        item.icon = 'static/icon/icon-business-info-cn-03@128px.png';
                                    }
                                });
                            }
                            if (this.language === 'en-us'){
                                _data.forEach(item=>{
                                    if (item.id === '5f2b640277337d1f84c2d935'){
                                        item.icon = 'static/icon/icon-business-info-en-01@128px.png';
                                    } else if (item.id === '5f2b9bbb77337d1f84c2d93c'){
                                        item.icon = 'static/icon/icon-business-info-en-02@128px.png';
                                    } else if (item.id === '5f2b9bcf77337d1f84c2d93d'){
                                        item.icon = 'static/icon/icon-business-info-en-03@128px.png';
                                    }
                                });
                            }
                        this.businessList = _data;
                        // console.log('<---------- res ---------->');
                        // console.log(this.businessList);
                    } else {
                        this.$Message.error('数据加载错误');
                    }
                }).catch((err) => {
                    this.$Message.error(err.message);
                });
            },

            onBusiness(data, i){
                console.log(data, i);
                this.isDetailsModal = true;
                this.detailsModalData = data;
            },
            detailsModalActions(data){
                console.log(data);
                this.isDetailsModal = data;
            },
            // 计算旋转动画
            autoRotation(){
                $.fn.Roate = function(opts){
                    var roateInter = null;
                    var $this = this;
                    opts = $.extend({
                        R: 100,
                        R0: 0,
                        cx: 0,
                        cy: 0,
                        step: 1.5,
                        delay: 50,
                        direction: true, // 逆时针或逆时针
                        roateItem: '.item',
                    }, opts || {});

                    var width = $this.width();
                    var height = $this.height();
                    if(!opts.cx){
                        opts.cx = width / 2;
                    }
                    if(!opts.cy){
                        opts.cy = height / 2;
                    }
                    var $item = $this.find(opts.roateItem);
                    var size = $item.size();
                    var roate = 0;
                    opts.R0 = opts.R0 === 0 ? opts.R:opts.R0;
                    roateInter = setInterval(function(){
                        for (var i = 0; i < size; i++) {
                            var left = opts.cx + opts.R * Math.sin(Math.PI / 180 * (roate + 360 * i / size));
                            var top = opts.cy + opts.R0 * Math.cos(Math.PI / 180 * (roate + 360 * i / size));
                            var $roate = $item.eq(i);
                            var rheight = $roate.height() / 2;
                            var rwidth = $roate.width() / 2;
                            $roate.css({
                                left: left - rheight,
                                top: top - rwidth
                            });
                        };
                        if(opts.direction){
                            roate -= opts.step;
                        }else{
                            roate += opts.step;
                        }
                    }, opts.delay);
                    this.children('.item').mousemove(function(event) {
                        // console.log('mousemove');
                        // console.log(this);
                        opts.step = 0;
                        // if(event.offsetX < width / 2){
                        //     opts.direction = false;
                        // }else{
                        // 	opts.direction = true;
                        // }
                    });
                    this.children('.item').mouseout(function(event) {
                        // console.log('mouseout');
                        // console.log(this);
                        opts.step = 0.8;
                        // if(event.offsetX < width / 2){
                        // 	opts.direction = false;
                        // }else{
                        // 	opts.direction = true;
                        // }
                    });
                };
                $(function(){
                    $('#rotation-one').Roate({
                        R: 250,
                        step: 0.8,
                        delay: 60,
                    });
                    $('#rotation-two').Roate({
                        R: 192,
                        R0: 57,
                        direction: false,
                        step: 1,
                        delay: 60,
                    });
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/business/list.vue